module.exports = __webpack_public_path__ + "media/spin.46f161c1.webm";